import { INPUT_CLASS, fieldClass } from "./Field";
import { SearchIcon } from "./icons";

/*
  Figma "Search field": 36px, 10px side padding, a 16px search icon, Callout text.
  Same fill, hover and focus outline as the text field.
*/
const SearchField = ({ label, className = "", ...inputProps }) => (
  <div className={fieldClass({ height: "h-[36px]", className: `gap-space-8 px-[10px] ${className}` })}>
    <SearchIcon className="shrink-0 text-label-secondary" />
    <input type="search" aria-label={label || inputProps.placeholder} className={INPUT_CLASS} {...inputProps} />
  </div>
);

export default SearchField;
